import { Outlet } from "react-router";

import { HelpCenterPanel } from "@/modules/help-center";
import { AppSlogan } from "@/ui/app-slogan";
import { StaticLayout } from "@/ui/static-layout";

import { getCarouselSlides } from "./auth-layout.helper";

import "./auth-layout.style.less";

const SLIDES = getCarouselSlides();

const AuthLayout = () => {
  return (
    <StaticLayout
      className="auth-layout"
      slides={SLIDES}
      header={<AppSlogan />}
      content={<Outlet />}
      footer={<HelpCenterPanel />}
    />
  );
};

export default AuthLayout;
